import initializeCesLetterScripts from './initializeCesLetterScripts';

document.addEventListener('DOMContentLoaded', () => {
  initializeCesLetterScripts();
});
